import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore } from '@pascal/pascal-core';
import { chartStore } from '../../../store/chartStore';
import { brandedGameIds } from '../../../enums/brandedPartners';

const Parabola = observer(() => {
  const [animationStartedAt, setAnimationStartedAt] = useState(0);
  const { isStarted, launchTime, isRoundFinish, isAnimationState } = chartStore;
  const { gameId } = gameConfigStore;

  const isEcuabet = brandedGameIds.ecuabet === +gameId;

  useEffect(() => {
    if (isStarted && !isRoundFinish) {
      setAnimationStartedAt((launchTime - Date.now()) / 1000);
    }

    if (isRoundFinish) {
      setAnimationStartedAt(0);
    }

    return () => setAnimationStartedAt(0);
  }, [isStarted, isRoundFinish, isAnimationState]);

  const delay = () => {
    if (isStarted && animationStartedAt < 0) {
      return `${animationStartedAt}s`;
    }
    return '0s';
  };

  return (
    isStarted && (
      <div
        className={`crash-game-line-chart ${isRoundFinish ? 'pause-chart' : ''}`}
        style={{ animationDuration: '6.3s', animationDelay: delay() }}
      >
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 790 516'>
          {!isEcuabet && (
            <defs>
              <linearGradient id='pathGradient' gradientTransform='rotate(80)'>
                <stop offset='0%' stopColor='#fd4a95' stopOpacity='0.5'>
                  <animate
                    attributeName='stop-color'
                    values='#fd4a95; #494be1; #39c77f; #fd4a95'
                    dur='2s'
                    repeatCount='indefinite'
                  />
                </stop>
                <stop offset='100%' stopColor='#ff9954' stopOpacity='0'>
                  <animate
                    attributeName='stop-color'
                    values='#ff9954; #ff6de8; #009eff; #ff9954'
                    dur='2s'
                    repeatCount='indefinite'
                  />
                </stop>
              </linearGradient>
            </defs>
          )}
          <path
            className='glc-g'
            d='M790,516H0L0,410.1C274.03013,325.17245,509.13669,190.059,701.62815,0H790Z'
          >
            {isEcuabet && (
              <animate
                attributeName='fill'
                values='#FFD028; #FF8747; #B3FF39; #FFD028'
                dur='2s'
                repeatCount='indefinite'
              />
            )}
          </path>
          <path d='M790,516H0L0,410.1C307.15109,408.69073,604.58475,296.45161,701.62815,0H790Z' />
          <path d='M790,516H0L0,410.1C395,410.1,701.62815,335.7353,701.62815,0H790Z' />
        </svg>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 790 516'>
          {!isEcuabet && (
            <defs>
              <linearGradient id='lineGradient' gradientTransform='rotate(80)'>
                <stop offset='0%' stopColor='#fd4a95' stopOpacity='1'>
                  <animate
                    attributeName='stop-color'
                    values='#fd4a95; #494be1; #39c77f; #fd4a95'
                    dur='2s'
                    repeatCount='indefinite'
                  />
                </stop>
                <stop offset='100%' stopColor='#ff9954' stopOpacity='1'>
                  <animate
                    attributeName='stop-color'
                    values='#ff9954; #ff6de8; #009eff; #ff9954'
                    dur='2s'
                    repeatCount='indefinite'
                  />
                </stop>
              </linearGradient>
            </defs>
          )}
          <path
            className='glc-l'
            d='M790,516H0L0,410.1C274.03013,325.17245,509.13669,190.059,701.62815,0H790Z'
          >
            {isEcuabet && (
              <animate
                attributeName='stroke'
                values='#FFD028; #FF8747; #B3FF39; #FFD028'
                dur='2s'
                repeatCount='indefinite'
              />
            )}
          </path>
          <path d='M790,516H0L0,410.1C307.15109,408.69073,604.58475,296.45161,701.62815,0H790Z' />
          <path d='M790,516H0L0,410.1C395,410.1,701.62815,335.7353,701.62815,0H790Z' />
        </svg>
      </div>
    )
  );
});

export default Parabola;
